import Ext from 'Ext'
import AbstractDropdownButton from '../abstract_dropdown_button'
import messageResource from '../../messageResource'
import {areDatesEqual} from '../../atUtils'

const AbstractPickerButton = Ext.extend(AbstractDropdownButton, {

    menuListeners: {
        select: function ( m, d )
        {
            this.updateValueAndFireIfChanged( m, d );
        }
    },

    updateValueAndFireIfChanged: function(m ,d)
    {
        var oldDate = this.date;
        this.setValue( d );
        if( !oldDate || !areDatesEqual( oldDate, d ) )
            this.fireEvent( "change", this, d );
    },


    // abstract
    createMenu: function()
    {

    },

    initComponent: function ()
    {
        this.cls = "at-dropdown-list-btn dateButton";
        this.ctCls = "at-dropdown-list-btn-ct";
        if( !this.format )
            this.format = Date.convertSmartToExtDateFormat( window.SystemSettings.dateFormat );

        AbstractPickerButton.superclass.initComponent.call( this );

        this.menu = this.createMenu();

        this.addEvents( "change" );

        this.menu.on( Ext.apply( {}, this.menuListeners, { scope: this } ) );
        if( this.date )
            this.displayValue( this.date );
        else
        {
            this.unsetValue();
            this.fireEvent( "change", this );
        }
    },

    formatDate: function ( date )
    {
        return Ext.isDate( date ) ? date.format( this.format ) : date.toString();
    },

    setValue: function ( date )
    {
        this.date = date;
        this.displayValue( date );
        this.menu.picker.setValue( date );
    },

    /**
     * Displays the given date, but doesn't actually change the date (the user didn't submit the date picker yet).
     * @param date
     */
    displayValue: function ( date )
    {
        this.setText( date ? this.formatDate( date ) : messageResource.getMessage( "common.date_selector.select_date" ) );
    },

    unsetValue: function ()
    {
        this.date = null;
        this.displayValue( null );
    },

    getValue: function ()
    {
        return this.date;
    }
} );

export default AbstractPickerButton



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_abstract_picker_button.js